export default __webpack_public_path__ + "static/media/alarm.c74b0cc9.mp3";